import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const EnvelopSvg = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' viewBox='0 0 25 25' fill='none'>
    <path
      d='M4.95312 4.44531H20.9531C22.0531 4.44531 22.9531 5.34531 22.9531 6.44531V18.4453C22.9531 19.5453 22.0531 20.4453 20.9531 20.4453H4.95312C3.85312 20.4453 2.95312 19.5453 2.95312 18.4453V6.44531C2.95312 5.34531 3.85312 4.44531 4.95312 4.44531Z'
      stroke='url(#paint0_linear_9757_9260)'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M22.9531 6.44531L12.9531 13.4453L2.95312 6.44531'
      stroke='url(#paint1_linear_9757_9260)'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <defs>
      <linearGradient
        id='paint0_linear_9757_9260'
        x1='2.95312'
        y1='4.44531'
        x2='23.669'
        y2='5.43312'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FE901F' />
        <stop offset='1' stopColor='#A94AC7' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_9757_9260'
        x1='2.95312'
        y1='6.44531'
        x2='23.4723'
        y2='8.68173'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FE901F' />
        <stop offset='1' stopColor='#A94AC7' />
      </linearGradient>
    </defs>
  </svg>
);

export const EnvelopColorIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={EnvelopSvg} {...props} />
);
